/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useContext } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import { ThemeContext } from "styled-components"

import MadeFontURL from "../assets/fonts/maade-carving/MADECarvingSoft-Black.woff"
import MadeFontURL2 from "../assets/fonts/maade-carving/MADECarvingSoft-Black.woff2"

import NCLFontURL from "../assets/fonts/ncl-qikober/ncl-qikober-regular.woff"
import NCLFontURL2 from "../assets/fonts/ncl-qikober/ncl-qikober-regular.woff2"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  const themeContext = useContext(ThemeContext)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `theme-color`,
          content: themeContext.color.primary,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link
        rel="preload"
        as="font"
        href={MadeFontURL}
        type="font/woff"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href={MadeFontURL2}
        type="font/woff2"
        crossOrigin="anonymous"
      />

      <link
        rel="preload"
        as="font"
        href={NCLFontURL}
        type="font/woff"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href={NCLFontURL2}
        type="font/woff2"
        crossOrigin="anonymous"
      />

      <link rel="stylesheet" href="https://use.typekit.net/lnu8nqy.css" />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
